import DeviceConfig from '@devices/config';
import FlavourConfig from '../../../../shared/config/flavours';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import TwoOptionsModal from './twoOptionsModal';
import AnalyticsInstance from '@shared/utils/analytics';

function ExitAppModal() {
  return (
    <TwoOptionsModal
      title={TranslationManager.get(
        'MODAL.EXIT_APP.TITLE',
        FlavourConfig.appTitle
      )}
      acceptAction={async () => {
        await AnalyticsInstance.getOmnitrackManager()?.closeApp();
        DeviceConfig.exit();
      }}
      allowedBack={false}
    />
  );
}

export default ExitAppModal;
